import React from 'react';
import { connect } from 'react-redux';
import {
  Button, Card, CardBody, CardTitle,
} from 'reactstrap';
import { Form, actions } from 'react-redux-form/immutable';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import qs from 'qs';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { LabeledText } from '../../../../../form/LabeledText';
import { LabeledSelect } from '../../../../../form/LabeledSelect';

import { depositSearchModel, toSearchParameters } from './depositSearchModel';

import {
  getPublications as getPublicationsAc,
  clearSearch as clearSearchAc,
  getBodiesOfWater as getBodiesOfWaterAc,
  getCountries as getCountriesAc,
  searchDeposits as searchDepositsAc,
  getGeologicAges as getGeologicAgesAc,
} from '../../../../../../redux/tsunamis/deposits/search/depositSearchActions';


import { Loading } from '../../../../../loadbar/Loading';

import { withUser } from '../../../../../auth/withUser';
import { isDataManager } from '../../../../../../role/roleUtils';
import { MinMaxSearchCard } from '../../../../../form/search/MinMaxSearchCard';
import { LatLongSearchCard } from '../../../../../form/search/LatLongSearchCard';
import { MinMaxSelectSearchCard } from '../../../../../form/search/MinMaxSelectSearchCard';
import { TextMatchSearchCard } from '../../../../../form/search/TextMatchSearchCard';

const model = depositSearchModel.get('name');

class DepositSearchPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Desposit Search';
    const {
      clearSearch, getBodiesOfWater, getCountries, getPublications, getGeologicAges,
    } = this.props;
    clearSearch();
    getBodiesOfWater();
    getPublications();
    getCountries();
    getGeologicAges();
  }

  handleSubmit(form) {
    const { searchDeposits } = this.props;
    const queryParameters = toSearchParameters(form);
    const location = {
      pathname: '/view/hazards/tsunami/deposit-data',
      search: qs.stringify(toSearchParameters(form), { skipNulls: true }),
    };
    searchDeposits({
      queryParameters, formModel: model, location, searchRedirect: true,
    });
  }

  render() {
    const {
      resetForm,
      searching,
      fetched,
      bodiesOfWater,
      publications,
      countries,
      authorities,
      geologicAges,
    } = this.props;

    if (!fetched || searching) {
      return (<Loading />);
    }

    const publicationsJs = publications.toJS();
    const geologicAgesJs = geologicAges.toJS();
    const bodiesOfWaterJs = bodiesOfWater.toJS();
    const countriesJs = countries.toJS();
    const dataManager = isDataManager(authorities);

    return (
      <div className="haz-results-container haz-page-container">
        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">Search Deposit References</CardTitle>
            <p>The NCEI/WDS Tsunami Deposit databases fosters the extension of an area’s tsunami hazard profile.</p>
            <p>
              Please cite as:
              <br />
              <a href="https://data.noaa.gov/metaview/page?xml=NOAA/NESDIS/NGDC/MGG/Hazards//iso/xml/G10146.xml&view=getDataView&header=none" rel="noopener noreferrer" target="_blank" title="Deposit DOI Information" aria-label="Deposit DOI Information">National Geophysical Data Center / World Data Service: NCEI/WDS Global Tsunami Deposit Database. NOAA National Centers for Environmental Information.</a>
            </p>

            <Form model={model} onSubmit={this.handleSubmit} noValidate>

              <div>
                <Button color="primary" type="submit" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" onClick={resetForm}>Clear</Button>
              </div>
              <br />

              { dataManager && (
              <Card>
                <CardBody>
                  <CardTitle tag="h2">Deposit ID</CardTitle>
                  <LabeledText model=".id" label="ID" />
                  <MinMaxSearchCard min=".minId" max=".maxId">ID Range</MinMaxSearchCard>
                </CardBody>
              </Card>
              )}

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Deposit Parameters</CardTitle>
                  <TextMatchSearchCard
                    radioGroupModel=".radios.authorSearchType"
                    textModel=".radios.author"
                    startsWith="authorStart"
                    includes="authorInclude"
                    matches="authorMatch"
                    doesNotMatch="authorNot"
                  >
                    Author
                  </TextMatchSearchCard>

                  <div className="form-row">
                    <LabeledSelect childOptions={publicationsJs} formGroupClassName={['col']} parentModel={model} fieldId="publicationType" label="Publication Type" prependId />
                  </div>

                  <TextMatchSearchCard
                    radioGroupModel=".radios.eventSearchType"
                    textModel=".radios.event"
                    startsWith="eventStart"
                    includes="eventInclude"
                    matches="eventMatch"
                    doesNotMatch="eventNot"
                  >
                    Event Description
                  </TextMatchSearchCard>

                  <div className="form-row row-margin-fix">
                    <MinMaxSelectSearchCard
                      className="col-lg-9"
                      model={model}
                      minField="maxGeologicAgeId"
                      maxField="minGeologicAgeId"
                      descriptors={geologicAgesJs}
                      prependId
                      descending
                      minLabel="Min (youngest)"
                      maxLabel="Max (oldest)"
                    >
                      Geologic Age
                    </MinMaxSelectSearchCard>

                    <MinMaxSearchCard
                      className="col-lg-3"
                      min=".minYear"
                      max=".maxYear"
                    >
                      Year, example: 200 B.C. = -200
                    </MinMaxSearchCard>
                  </div>


                  <div className="form-row">
                    <LabeledSelect childOptions={bodiesOfWaterJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="bodyOfWater" label="Body of Water" filterable />
                    <LabeledSelect childOptions={countriesJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="country" label="Country" filterable />
                  </div>

                  <TextMatchSearchCard
                    radioGroupModel=".radios.locationSearchType"
                    textModel=".radios.loc"
                    startsWith="locStart"
                    includes="locInclude"
                    matches="locMatch"
                    doesNotMatch="locNot"
                  >
                    Location
                  </TextMatchSearchCard>

                  <LatLongSearchCard model={model} />

                </CardBody>
              </Card>

              <br />
              <div>
                <Button color="primary" type="submit" aria-label="Search Option 2" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" aria-label="Clear Option 2" onClick={resetForm}>Clear</Button>
              </div>

            </Form>
          </CardBody>
        </Card>
      </div>
    );
  }
}

DepositSearchPageUnwrapped.propTypes = {
  resetForm: PropTypes.func.isRequired,
  searching: PropTypes.bool.isRequired,
  fetched: PropTypes.bool.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
  clearSearch: PropTypes.func.isRequired,
  getPublications: PropTypes.func.isRequired,
  getBodiesOfWater: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  getGeologicAges: PropTypes.func.isRequired,
  searchDeposits: PropTypes.func.isRequired,
  publications: ImmutablePropTypes.list.isRequired,
  bodiesOfWater: ImmutablePropTypes.list.isRequired,
  countries: ImmutablePropTypes.list.isRequired,
  geologicAges: ImmutablePropTypes.list.isRequired,
};


const mapStateToProps = state => ({
  searching: state.getIn(['depositSearchPage', 'searching']),
  fetched: [
    state.getIn(['depositSearchPage', 'fetchedPublications']),
    state.getIn(['depositSearchPage', 'fetchedCountries']),
    state.getIn(['depositSearchPage', 'fetchedBodiesOfWater']),
    state.getIn(['depositSearchPage', 'fetchedGeologicAges']),
  ].every(v => v),
  countries: state.getIn(['depositSearchPage', 'countries']),
  bodiesOfWater: state.getIn(['depositSearchPage', 'bodiesOfWater']),
  publications: state.getIn(['depositSearchPage', 'publications']),
  geologicAges: state.getIn(['depositSearchPage', 'geologicAges']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getPublications: getPublicationsAc,
  clearSearch: clearSearchAc,
  getBodiesOfWater: getBodiesOfWaterAc,
  getCountries: getCountriesAc,
  getGeologicAges: getGeologicAgesAc,
  searchDeposits: searchDepositsAc,
  resetForm: () => actions.reset(model),
}, dispatch);

export const DepositSearchPage = withUser(connect(mapStateToProps, mapDispatchToProps)(DepositSearchPageUnwrapped));
